
import React from 'react';
import { Box, Typography } from '@mui/material';

export const SEOHelper: React.FC = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                border: 0,
            }}
        >
            <Typography variant="h1">Digipin Explorer - Precise Digital Address System for India</Typography>
            <p>
                Welcome to <strong>thedigipin.net</strong>, the official home of Digipin Explorer.
                Convert latitude and longitude coordinates into short, shareable Digipin codes.
            </p>
            <h2>What is a Digipin?</h2>
            <p>
                DIGIPIN (Digital Postal Index Number) is an alphanumeric geographical location code designed specifically for India.
                It provides a precise digital address for every 4m x 4m area, enabling accurate logistics, emergency response, and navigation.
            </p>
            <h2>Tools and Features</h2>
            <ul>
                <li><strong>Latitude Longitude Converter:</strong> Instantly encode coordinates to Digipin and decode Digipin back to locations.</li>
                <li><strong>Batch Processing:</strong> Convert thousands of addresses in bulk.</li>
                <li><strong>Digipinjs:</strong> Powered by the open-source <strong>digipinjs</strong> library for accurate encoding and decoding.</li>
                <li><strong>Distance Calculator:</strong> Measure precise distances between any two points in India.</li>
            </ul>
        </Box>
    );
};
